import React from 'react';

export default function Layanan(){
  return (
    <main style={{padding:16}}>
      <h1>Layanan</h1>
      <p>Daftar layanan klinik.</p>
    </main>
  );
}
